module.exports = __webpack_public_path__ + "static/assets/c5b3d36982acf8f9acc53c3964100460.mp3";